import React, { useContext, useMemo } from 'react';
import * as _ from 'lodash';
import classnames from 'classnames';
import { useParams } from 'react-router-dom';

import './styles.scss';
import OddConverter from '@common/helpers/oddConverter';
import { useTranslation } from '@common/hooks/translation';
import { PreferencesContext } from '@common/contexts/preferences';
import { RacingMarketTypes } from '@common/constants/enums/racingMarketTypes';
import { useSelections } from '@racings/hooks/selections';
import { nthNumber } from '@common/helpers/nthNumber';
import { RacingsContext } from '@racings/store/context';

// need some refactor after all logics will work

export const RacingFutureSpecialEvent = ({
    game, event, market, activeMarketId, marketDisplayKey,
}) => {
    const t = useTranslation();
    const [{ oddsFormat }] = useContext(PreferencesContext);
    const [{ id , config}] = useContext(RacingsContext);
    const { compId, regionId } = useParams();
    const [events, toggleEvent] = useSelections();
    const allEventsList = useMemo(() => Object.values(events), [events]);
    const selectedFirstEvent = allEventsList[0];

    const priceHistory = event.extra_info?.PriceHistory ?? [];

    function takeBeforeLast(arr) {
        const n = arr.length;

        if (n <= 1 || !arr.length) return [];
        const count = Math.min(n - 1, 3);

        return arr.slice(n - 1 - count, n - 1);
    }
    const filteredPriceHistory = takeBeforeLast(priceHistory);

    const toggleEventWrapper = (event) => toggleEvent({
        event, activeMarketId, game, market, regionId, competitionId: compId,
    });

    const renderPrices = () => {
        const isEventDisabled = (eventToCheck, eventsList, option, maxOption) => {
            const eventsByOptions = _.groupBy(events, (event) => event.event.eventOption);

            if (selectedFirstEvent && selectedFirstEvent.event.marketType !== activeMarketId) return true;
            if (selectedFirstEvent && selectedFirstEvent.game.id !== game.id) return true;

            return (
                !!eventsByOptions[maxOption]
                || eventsList.some(
                    ({ event: forecastEvent }) => forecastEvent.id === eventToCheck.id && forecastEvent.eventOption !== option,
                )
                || (eventsByOptions[option] && eventsByOptions[option][0].event.id !== eventToCheck.id)
            );
        };

        let eventItems = [];

        if (activeMarketId === RacingMarketTypes.WINNER) {
            const price = OddConverter(config, event.price, oddsFormat, null, marketDisplayKey);
            const selectedEvent = events[event.id];

            const isDisabled = allEventsList.some(
                ({ event }) => event.marketType && event.marketType !== RacingMarketTypes.WINNER,
            );

            if (price) {
                eventItems.push(
                    <div
                        onClick={() => toggleEventWrapper({ ...event, sp: false })}
                        className={classnames('price-item', {
                            disabled: isDisabled,
                            active: selectedEvent && selectedEvent.event.price !== -1 && !selectedEvent.event.eventOption,
                        })}
                    >
                        {price}
                    </div>,
                );
            }

            if (event.sp_enabled) {
                eventItems.push(
                    <div
                        onClick={() => toggleEventWrapper({
                            ...event,
                            sp: true,
                            price: -1,
                        })}
                        className={classnames('price-item', {
                            disabled: isDisabled,
                            active:
                                selectedEvent
                                && selectedEvent.event.isRacingEvent
                                && selectedEvent.event.price === -1
                                && !selectedEvent.event.eventOption,
                        })}
                    >
                        {t('SP')}
                    </div>,
                );
            }
        } else {
            const itemsCount = activeMarketId === RacingMarketTypes.FORECAST ? 3 : 4;
            const eventsList = allEventsList.filter(({ event }) => event.marketType === activeMarketId);

            const optionsArray = Array.from({ length: itemsCount }, (_, curr) => curr + 1);
            let lastOption = '';

            eventItems = optionsArray.map((eventOption) => {
                const optionNth = nthNumber(eventOption);
                const selectedEvent = events[event.id];
                const isLastOption = eventOption === itemsCount;
                lastOption += !isLastOption ? `${optionNth} ${eventOption !== itemsCount - 1 ? 'or ' : ''}` : '';

                const optionViewLabel = isLastOption ? lastOption : optionNth;

                return (
                    <div
                        key={eventOption}
                        onClick={() => toggleEventWrapper({
                            ...event,
                            eventOption,
                            price: -1,
                            sp: false,
                            optionViewLabel,
                            marketType: activeMarketId,
                        })}
                        className={classnames('price-item', {
                            disabled: isLastOption
                                ? (selectedFirstEvent
                                    && (activeMarketId !== selectedFirstEvent.event.marketType
                                        || selectedFirstEvent.game.id !== game.id))
                                || allEventsList.some(({ event }) => event.eventOption !== eventOption)
                                : isEventDisabled(event, eventsList, eventOption, itemsCount),
                            active:
                                selectedEvent
                                && selectedEvent.event.eventOption === eventOption
                                && selectedEvent.event.marketType === activeMarketId,
                        })}
                    >
                        {optionViewLabel}
                    </div>
                );
            });
        }
        return eventItems;
    };

    return (
        <div className={`fs-racing-event-row ${+id === 153 && 'special'}`} key={event.id}>
            <div className="row-item">

                <div className="about-container">
                    <div className="name">{event.name}</div>

                </div>
            </div>
            <div className="right-container">
                <div className="event-price-container">{renderPrices()}</div>
            </div>
        </div>
    );
};
